
// Disabling this warning, just for clarity.
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable react/no-deprecated */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

/**
 * We are disabling the react/no-deprecated,
 * we are not ready yet to upgrade to ES 6 syntax.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import tsRest from 'ts-rest-client';
import { map, find, size, reject } from 'lodash';
import { PasswordEditionPanel } from './passwordpages';
import TranslatorManager from 'ts-translate-js';
import { ConfirmYesNo } from './modal';
import { ResponsivenessGrid } from '../toolkit';
import cIf from 'classnames';
import { EMPTY_UUID } from '../util';

let up = require('react-addons-update');
let tr = TranslatorManager.boundTR;

const createClass = require('create-react-class');

export class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userid: tsapp.user.pi,
            profile:null,
            profileEditionInProgress: false,
            errorOnAction: "",
            showProfileEditionError: false,
            restoreParentScrollNextRender: false,
            showRegisterProfile: false,
            showEditProfile: false,
            showPassword: false,
            showEmailEdition: false,
        };

        this.loginRequest = null;
        this.handleOnProfileChange = this.handleOnProfileChange.bind(this);
        this.handleOnConnect = this.handleOnConnect.bind(this);
        this.handleOnCancelEdition = this.handleOnCancelEdition.bind(this);
        this.handleOnCompleteRegisterProfile = this.handleOnCompleteRegisterProfile.bind(this);
        this.handleOnCompleteUpdateProfile = this.handleOnCompleteUpdateProfile.bind(this);
        this.handleOnRegisterProfile = this.handleOnRegisterProfile.bind(this);
        this.handleOnEditProfile = this.handleOnEditProfile.bind(this);
        this.handleOnFailedProfileEditionOK = this.handleOnFailedProfileEditionOK.bind(this);
        this.handleOnValidationIncorrect = this.handleOnValidationIncorrect.bind(this);
        this.handleOnEditEmail = this.handleOnEditEmail.bind(this);
        this.getReadOnlyProfile = this.getReadOnlyProfile.bind(this);
    }
    
    componentDidMount(){
        this.loadProfile();
        
        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    }

    componentWillUnmount() {
        if (this.registerProfileRequest != null) this.registerProfileRequest.abort();
        if (this.loginRequest != null) this.loginRequest.abort();
        if (this.updateProfileRequest != null) this.updateProfileRequest.abort();
        if (this.itemRequest != null) this.itemRequest.abort();
    }

    loadProfile(){
        this.itemRequest = tsapp.mvcapi.postCtl("profile/ProfileInfo")
                                .success(function(data){
                                    let profile = up(data.profile, { [ "PasswordValidation" ]: { $set: data.profile.Password }} );
                                    this.setState({profile});
                                }.bind(this))
        // eslint-disable-next-line lodash/prefer-noop
                                .notSuccess(function(){
                                    // TODO: What do we hate to do here?
                                }.bind(this));
    }

    handleOnProfileChange(profile){
        this.setState ({profile});
    }

    handleOnConnect(){
        // Google Analytics virtual page
        if(typeof dataLayer !== "undefined") dataLayer.push({ event: 'form-submit', "form-type": 'formulaire-connexion-compte' });

        // Refresh the cart status widget if applies.

        this.itemRequest = tsapp.mvcapi.postCtl("login/CurrentUserInfo")
                                .success(function(data){
                                    this.setState({ userid:data.user.pi, publicUserAuthenticated: data.user.pua });
                                    this.loadProfile();
                                    tsapp.goToHome(this.integ);
                                }.bind(this))
                                .notSuccess(function(data){
                                    this.setState({errorOnAction:(data.message == "CART_IS_EMPTY") ? data.message: ""});
                                }.bind(this));
    }

    handleOnCancelEdition() {
        if (this.props.goBack) {
            window.history.back();
        } else {
            this.setState({showEditProfile:false, showRegisterProfile:false, profileEditionError:null, showProfileEditionError:false, showEmailEdition: false});
            this.loadProfile();
            this.setState({restoreParentScrollNextRender:true});
        }
    }

    handleOnCompleteRegisterProfile(){
        this.setState({profileEditionInProgress: true, showProfileEditionError:false});

        // Google Analytics virtual page
        if(typeof dataLayer != 'undefined') dataLayer.push({ event: 'form-submit', "form-type": 'formulaire-creation-compte' });

        this.registerProfileRequest = tsapp.mvcapi.postCtl("profile/register", {profile:this.state.profile})
                                           .success(function(){
                                                // @ts-ignore
                                               this.loginRequest = tsapp.mvcapi.postCtl("login/login", {email:this.state.profile.EmailAddress, password:this.state.profile.Password})
                                                                        .success(function(){
                                                                            this.setState({ showRegisterProfile:true, profileEditionInProgress: false, restoreParentScrollNextRender:true});
                                                                            this.handleOnConnect();
                                                                        }.bind(this));
                                           }.bind(this))
                                           .notSuccess(function(data){
                                               this.setState({ showProfileEditionError:true,
                                                               profileEditionInProgress: false,
                                                               profileEditionError: data});
                                           }.bind(this));
    }

    handleOnCompleteUpdateProfile(){
        this.setState({profileEditionInProgress: true, showProfileEditionError:false, profileEditionError:null});

        this.updateProfileRequest = tsapp.mvcapi.postCtl("profile/UpdateProfile", {profile:this.state.profile})
                                         .success(function(){
                                             this.setState({showEditProfile:false, profileEditionInProgress: false, restoreParentScrollNextRender:true});
                                         }.bind(this))
                                         .notSuccess(function(data){
                                             this.setState({
                                                 showProfileEditionError:true,
                                                 profileEditionInProgress: false,
                                                 profileEditionError: data,
                                                 errorOnAction:(data.message == "PROFILE_IS_EMPTY") ? data.message: ""
                                             });
                                         }.bind(this));

        this.setState({restoreParentScrollNextRender:true});
    }

    handleOnRegisterProfile(){
        this.setState({showRegisterProfile:true});

        if(getScrollPosition)
            getScrollPosition(function(pos){this.saveParentScroll(pos);}.bind(this));

        if(scrollParentTop)
            scrollParentTop();
    }
    
    handleOnEditProfile(){
        this.setState({showEditProfile:true});
    }

    handleOnFailedProfileEditionOK(){
        this.setState({showProfileEditionError: false});
    }

    handleOnValidationIncorrect(){
        this.setState({showProfileEditionError:true});
    }

    handleOnEditEmail() {
        this.setState(prevState => ({
            showEmailEdition: !prevState.showEmailEdition
        }));
    }

    getReadOnlyProfile(){
        let keyIndex = 0;

        let isMale = this.state.profile.IsMale ? tr("Homme") : tr("Femme");

        let address = [<React.Fragment key={keyIndex++}>{this.state.profile.MainAddress.Description}</React.Fragment>,
                       <br key={keyIndex++}/>,
                       <React.Fragment key={keyIndex++}>{this.state.profile.MainAddress.Address1}</React.Fragment>,
                       <br key={keyIndex++}/>];

        if(this.state.profile.MainAddress.address2) {
            address.push(<React.Fragment key={keyIndex++}>{this.state.profile.MainAddress.Address2}</React.Fragment>,
                         <br key={keyIndex++}/>);
        }

        address.push(this.state.profile.MainAddress.City,
                     <br key={keyIndex++}/>,
                     <React.Fragment key={keyIndex++}>{this.state.profile.MainAddress.Province}</React.Fragment>,
                     <React.Fragment key={keyIndex++}>{", "}</React.Fragment>,
                     <React.Fragment key={keyIndex++}>{this.state.profile.MainAddress.Country}</React.Fragment>,
                     <br key={keyIndex++}/>,
                     <React.Fragment key={keyIndex++}>{this.state.profile.MainAddress.PostalCode}</React.Fragment>,
                     <br key={keyIndex++}/>);
        
        return (
            <div className="profile">
                <h3 className="panel-tab-header">{tr("Profil")}</h3>
                <ResponsivenessGrid 
                    nbrColumnsByBreakpointConfigs={{ mobile: 1, tablet: 2, small: 2, large: 2 }}
                    items={[
                        <div key="contact">
                            <label className="control-label">{tr("Contact")}</label> <br />
                            {this.state.profile.FirstName} {this.state.profile.LastName}<br/>
                        {isMale}<br/>
                        {tr("profileinfo.phone2")} : {this.state.profile.PhoneEvening}<br/>
                        {tr("profileinfo.phone1")}<em>{tr("profileedition.optional")}</em> : {this.state.profile.PhoneDay}<br/>
                        {tr("Email")} : {this.state.profile.EmailAddress} 
                        <button onClick={this.handleOnEditEmail} className="btn btn-xs update-email-btn">
                            {tr("Modifier")} 
                            <i className="fas fa-pencil-alt icon" aria-hidden="true"></i>
                        </button><br/>
                        </div>,
                        <div key="address">
                            <label className="control-label">{tr("Adresse de facturation")}</label> 
                            <address>
                                {address}
                            </address>
                        </div>
                    ]}
                />
                <div className="text-right">
                    <button onClick={this.handleOnEditProfile} className="btn btn-primary">
                        {tr("Modifier le profil")} 
                        <i className="fas fa-pencil-alt icon" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        );
    }

    render() {
        let userPanel = null;
        let addressesPanel = null;
        let passwordPanel = null;

        if(this.state.profile != null) {
            if(this.props.showRegisterProfile || this.state.showEditProfile ) {
                /** 
                 * Need this because eslint doesn't understand <tsapp.ctl> directly, event if tsapp is globally defined in eslint config.
                 * Could also add an eslint disabling rule.
                 */ 
                const tsappCtls = tsapp.ctl; 
                userPanel = <tsappCtls.profile.EditionPanel profile={this.state.profile}
                                                            onCompleteEdition={this.state.showEditProfile
                                                                              ?this.handleOnCompleteUpdateProfile
                                                                              :this.handleOnCompleteRegisterProfile}
                                                            onCancelEdition={this.handleOnCancelEdition}
                                                            onProfileChange={this.handleOnProfileChange}
                                                            profileEditionError={this.state.profileEditionError}
                                                            showProfileEditionError={this.state.showProfileEditionError}
                                                            onFailedEditionOK={this.handleOnFailedProfileEditionOK}
                                                            isEdition={this.state.showEditProfile}
                                                            onValidationIncorrect={this.handleOnValidationIncorrect}
                                                            profileEditionInProgress={this.state.profileEditionInProgress}
                                                            showPassword={this.props.showRegisterProfile}
                                                            integ={this.props.integ}/>;
            }
            else if (this.state.showEmailEdition) {
                userPanel = <ProfileEmailModification userid={this.state.userid} handleOnEditEmail={this.handleOnEditEmail} onCancelEdition={this.handleOnCancelEdition}/>;
            }
            else
                userPanel = this.getReadOnlyProfile();
            
            if(this.state.userid != EMPTY_UUID) {   
                addressesPanel = <ShippingAddressesPanel userid={this.state.userid} />;
                passwordPanel = <PasswordEditionPanel profile={this.state.profile} />;
            }
        }      
        return (
            // <ResponsivenessGrid
            //     nbrColumnsByBreakpointConfigs={{ mobile: 1, tablet: 1, small: 1, large: 1 }}
            //     items={[
            <div>
                <div key="user">{userPanel}</div>
                <div className="spacer-row" />
                <div key="address">{addressesPanel}</div>
                <div className="spacer-row" />
                <div key="password">{passwordPanel}</div>
            </div>
        );
    }
}
Profile.propTypes = {
    showRegisterProfile: PropTypes.bool,
    integ: PropTypes.string,
    redirectToHomeOnCancel: PropTypes.bool,
    goBack: PropTypes.bool,
    onContentChange: PropTypes.func
};

export class ShippingAddressesPanel extends Component { 
    constructor(props) {
        super(props);

        this.state = {
            shippingAddresses: [],
            editAddress: false,
            deleteAddress: false,
            curAddress: null,
            toDeleteAddress: null
        };

        this.handleOnRemove = this.handleOnRemove.bind(this);
        this.handleOnRemoveConfirm = this.handleOnRemoveConfirm.bind(this);
        this.handleOnRemoveErrorShippingOK = this.handleOnRemoveErrorShippingOK.bind(this);
        this.handleModifyShippingAddress = this.handleModifyShippingAddress.bind(this);
        this.handleOnDeleteShippingAddress = this.handleOnDeleteShippingAddress.bind(this);
        this.handleOnModifyShippingAddress = this.handleOnModifyShippingAddress.bind(this);
        this.handleOnAddNewAddress = this.handleOnAddNewAddress.bind(this);
        this.handleOnCancelShippingAddressEdition = this.handleOnCancelShippingAddressEdition.bind(this);
        this.loadShippingAddresses = this.loadShippingAddresses.bind(this);
        this.handleSaveShippingAddresses = this.handleSaveShippingAddresses.bind(this);
        this.handleDeleteShippingAddress = this.handleDeleteShippingAddress.bind(this);
        this.isNew = this.isNew.bind(this);
    }
    
    componentDidMount(){
        this.loadShippingAddresses();
    }

    componentWillUnmount() {
        if (this.saveProm != null) this.saveProm.abort();
        if (this.shippingAddressesReq != null) this.shippingAddressesReq.abort();
        if (this.deleteAddressesReq != null) this.deleteAddressesReq.abort();
        if (this.shippingAddressesReq != null) this.shippingAddressesReq.abort();
    }

    handleOnRemove(addressID){
        this.handleOnRemoveConfirm(addressID);
    }

    handleOnRemoveConfirm(addressID){
        this.props.onRemoveShippingAddress(addressID);
    }
    
    handleOnRemoveErrorShippingOK(){
        this.props.onRemoveErrorShippingOK();
    }

    handleModifyShippingAddress(address){
        this.setState({editAddress: true, curAddress: address});
    }

    handleOnDeleteShippingAddress(id){
        this.handleDeleteShippingAddress(id);
    }

    handleOnModifyShippingAddress(shippingAddressToModify) {
        this.setState({curAddress: shippingAddressToModify, showEditShippingError:false});
    }

    handleOnAddNewAddress(){
        this.setState({editAddress: true, curAddress:{ID: EMPTY_UUID}});
    }

    handleOnCancelShippingAddressEdition(){
        this.setState({editAddress: false, curAddress:null});
    }

    loadShippingAddresses(){
        this.shippingAddressesReq = tsRest.get("/profiles/byuser/"+ this.props.userid +"/shippingaddresses");

        this.shippingAddressesReq
            .done(function(adresses){
                this.setState({ shippingAddresses: adresses });
            }.bind(this), function(err) {
                this.setState({ ts: null });
                return tsRest.handleError(err);
            }.bind(this));
    }

    handleSaveShippingAddresses(){
        if(this.isNew())
            this.saveProm = tsRest.post("/profiles/byuser/" + this.props.userid + "/shippingaddresses", this.state.curAddress);
        else {
            this.saveProm = tsRest.put("/profiles/byuser/" + this.props.userid + "/shippingaddresses/" + this.state.curAddress.ID, this.state.curAddress);
        }

        this.saveProm
            .done(function(){
                this.setState({ curAddress: null, editAddress: false, showEditShippingError: false, shippingAddressErrors: null });
                this.loadShippingAddresses();
            }.bind(this), function(err) {
                this.setState({ ts: null, shippingAddressErrors: err.body.FieldValidationErrors, showEditShippingError: true });
            }.bind(this));
    }

    handleDeleteShippingAddress(id){
        this.deleteAddressesReq = tsRest.delete("/profiles/byuser/" + this.props.userid + "/shippingaddresses/" + id);

        this.deleteAddressesReq
            .done(function(addressToDelete){
                this.setState({ shippingAddresses: reject(this.state.shippingAddresses, addressToDelete), deleteAddress: false });
            }.bind(this), function(err) {
                this.setState({ ts: null });
                return tsRest.handleError(err);
            }.bind(this));
    }

    isNew(){ return this.state.curAddress.ID === EMPTY_UUID; } // New when no ID provided

    render() {
        let allAddresses = null;

        if(this.state.shippingAddresses != null && !this.state.editAddress) {
            allAddresses = map(this.state.shippingAddresses, (address) => {
                return (
                    <ShippingAddress 
                        key={address.ID}
                        shippingAddress={address} 
                        onDelete={this.handleOnDeleteShippingAddress.bind(this, address.ID)} 
                        userid={this.props.userid} 
                        onModify={this.handleModifyShippingAddress}
                    />
                );
            });
        } else if(this.state.editAddress)
            allAddresses = (
                <ShippingAddressEdition 
                    shippingAddress={this.state.curAddress} 
                    onModifyShippingAddress={this.handleOnModifyShippingAddress} 
                    onSave={this.handleSaveShippingAddresses} 
                    onCancel={this.handleOnCancelShippingAddressEdition}
                    shippingAddressErrors={this.state.shippingAddressErrors}
                    showEditShippingError={this.state.showEditShippingError}
                />
            );

        return (
            <div>
                <h3 className="panel-tab-header">{tr("Adresses de livraison")}</h3>
                <ResponsivenessGrid 
                    nbrColumnsByBreakpointConfigs={{ mobile: 1, tablet: 2, small: 3, large: 4 }}
                    items={[
                        <div key="addresses">
                            {allAddresses}
                        </div>
                    ]}
                />
                {!this.state.editAddress ?
                 <div key="add-address">
                     <button onClick={this.handleOnAddNewAddress} className="btn btn-primary "> 
                         {tr("Ajouter")} 
                         <i className="fa fa-plus icon" aria-hidden="true"></i>
                     </button>
                 </div>
                : null}
            </div>
        );
    }
}
ShippingAddressesPanel.propTypes = {
    userid: PropTypes.string,
    onRemoveShippingAddress: PropTypes.func,
    onRemoveErrorShippingOK: PropTypes.func
};

export class ShippingAddress extends Component {
    constructor(props) {
        super(props);
        
        this.state = { showConfirmRemove: false };
        this.myRef = React.createRef();

        this.handleModifyShippingAddress = this.handleModifyShippingAddress.bind(this);
        this.handleDeleteShippingAddress = this.handleDeleteShippingAddress.bind(this);
        this.handleOnYesRemove = this.handleOnYesRemove.bind(this);
        this.handleOnNoRemove = this.handleOnNoRemove.bind(this);
    }

    handleModifyShippingAddress() {
        this.props.onModify(this.props.shippingAddress);
    }

    handleDeleteShippingAddress() {
        this.setState({showConfirmRemove: true});
    }

    handleOnYesRemove(){
        this.setState({showConfirmRemove: false});
        this.props.onDelete(this.props.shippingAddress.ID);
    }

    handleOnNoRemove(){
        this.setState({showConfirmRemove: false});
    }

    getAddress() {
        let keyIndex = 0;

        let address = [<React.Fragment key={keyIndex++}>{this.props.shippingAddress.Name}</React.Fragment>, 
                       <br key={keyIndex++} />,
                       <React.Fragment key={keyIndex++}>{this.props.shippingAddress.Address1}</React.Fragment>,  
                       <br key={keyIndex++}/> ];

        if(this.props.shippingAddress.Address2 != "") {
            address.push(<React.Fragment key={keyIndex++}>{this.props.shippingAddress.Address2}</React.Fragment>, 
                         <br key={keyIndex++} />);
        }

        address.push(<React.Fragment key={keyIndex++}>{this.props.shippingAddress.City}</React.Fragment>, 
                     <br key={keyIndex++}/>,
                     <React.Fragment key={keyIndex++}>{this.props.shippingAddress.Province}</React.Fragment>, 
                     <React.Fragment key={keyIndex++}>{", "}</React.Fragment>,
                     <React.Fragment key={keyIndex++}>{this.props.shippingAddress.Country}</React.Fragment>, 
                     <br key={keyIndex++}/>,
                     <React.Fragment key={keyIndex++}>{this.props.shippingAddress.PostalCode}</React.Fragment>, 
                     <br key={keyIndex++}/>);

        return address;

    }

    render() {
        let address = this.getAddress();

        let deletePopup;
        if(this.state.showConfirmRemove) {
            deletePopup = (
                <ConfirmYesNo 
                    title={tr("cartcontent.confirmtitle")}
                    messagehtml={tr('Désirez-vous vraiment supprimer cette adresse?')}
                    onNo={this.handleOnNoRemove}
                    onYes={this.handleOnYesRemove}
                    onClose={this.handleOnNoRemove}
                    style={this.state.confirmStyle}
                    container={this.myRef.current}
                />
            );
        }

        return (
            <div ref={this.myRef}>
                {deletePopup}
                <label htmlFor="inputDescription" className="control-label"> {this.props.shippingAddress.Description} </label> 
                <button 
                    onClick={this.handleModifyShippingAddress} 
                    className="btn btn-xs btn-left-spacer btn-default" aria-hidden="true"
                >
                    <i className="fas fa-pencil-alt" aria-hidden="true"></i>
                </button> 
                <button 
                    className="btn btn-xs btn-default btn-left-spacer" 
                    onClick={this.handleDeleteShippingAddress} aria-hidden="true"
                >
                    <i className="fa fa-ban" aria-hidden="true"></i>
                </button>
                <br />
                <address>
                    {address}
                </address>
            </div>
        );
    }
}
ShippingAddress.propTypes = {
    shippingAddress: PropTypes.object,
    onDelete: PropTypes.func,
    onModify: PropTypes.func,
    onCancel: PropTypes.func,
    userid: PropTypes.string,
    integ: PropTypes.string
};

const ShippingAddressEdition = createClass({
    displayName: "ShippingAddressEdition",

    propTypes: {
        shippingAddress: PropTypes.object,
        onSave: PropTypes.func,
        onModifyShippingAddress: PropTypes.func,
        userid: PropTypes.string,
        onCancel: PropTypes.func,
        shippingAddressErrors: PropTypes.arrayOf(PropTypes.shape({ FieldName: PropTypes.string, ErrorName: PropTypes.string })),
        showEditShippingError: PropTypes.bool
    },

    handleOnChange(name, e){
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { [ name ]: { $set: e.target.value } }));
    },

    handleOnSave(e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.onSave();
    },

    handleOnCancelEdition() {
        this.props.onCancel();
    },

    isFieldInvalid(fieldName) {
        return find(this.props.shippingAddressErrors, ['FieldName', fieldName]) != undefined;
    },

    isPostalCodeFormatInvalid() {
        const error =  find(this.props.shippingAddressErrors, ['FieldName', 'PostalCode']);
        return error != undefined && error.ErrorName === "INVALID_FORMAT";
    },

    render() {
        let formError, errorMessage;

        if (this.props.showEditShippingError) {
            if (size(this.props.shippingAddressErrors) > 0) {
                if (this.isPostalCodeFormatInvalid())
                    errorMessage = tr("Veuillez remplir tous les champs qui ne sont pas optionnels et vous assurer que le code postal est valide");
                else 
                    errorMessage = tr("Veuillez remplir tous les champs qui ne sont pas optionnels");
            }
            else if (this.isPostalCodeFormatInvalid())
                errorMessage = tr("Veuillez vous assurer que le code postal est valide");
            else
                errorMessage = tr("Une erreur est survenue. Veuillez réessayer.");

            formError = <div className="form-group">
                <div className="alert alert-danger text-center" style={{margin:"0"}} role="alert">{errorMessage}</div>
            </div>;
        }

        return (
            <form onSubmit={this.handleOnSave}>
                <div className={cIf(["form-group", {"has-error": this.isFieldInvalid("Description")}])}>
                    <label htmlFor="inputDescription" className="control-label">{tr("Description")}</label>
                    <input type="text" id="inputDescription" className="form-control" value={this.props.shippingAddress.Description || ""} onChange={this.handleOnChange.bind(this,"Description")}></input>
                </div>
                <div className={cIf(["form-group", {"has-error": this.isFieldInvalid("Name")}])}>
                    <label htmlFor="inputName" className="control-label">{tr("Nom")}</label>
                    <input type="text" id="inputName" className="form-control" value={this.props.shippingAddress.Name || ""} onChange={this.handleOnChange.bind(this,"Name")}></input>
                </div>

                <div className={cIf(["form-group", {"has-error": this.isFieldInvalid("Address1")}])}>
                    <label htmlFor="inputAddress1" className="control-label">{tr("Adresse")}</label>
                    <input type="text" id="inputAddress1" className="form-control" value={this.props.shippingAddress.Address1 || ""} onChange={this.handleOnChange.bind(this,"Address1")}></input>
                </div>

                <div className="form-group">
                    <label htmlFor="inputAddress2" className="control-label">{tr("Adresse (suite)")}</label><span> <em>{tr("Optionnel")}</em></span>
                    <input type="text" id="inputAddress2" className="form-control" value={this.props.shippingAddress.Address2 || ""} onChange={this.handleOnChange.bind(this,"Address2")}></input>
                </div>

                <div className={cIf(["form-group", {"has-error": this.isFieldInvalid("City")}])}>
                    <label htmlFor="inputCity" className="control-label">{tr("Ville")}</label>
                    <input type="text" id="inputCity" className="form-control" value={this.props.shippingAddress.City || ""} onChange={this.handleOnChange.bind(this,"City")}></input>
                </div>

                <div className={cIf(["form-group", {"has-error": this.isFieldInvalid("Province")}])}>
                    <label htmlFor="inputProvince" className="control-label">{tr("Province")}</label>
                    <input type="text" id="inputProvince" className="form-control" value={this.props.shippingAddress.Province || ""} onChange={this.handleOnChange.bind(this,"Province")}></input>
                </div>

                <div className={cIf(["form-group", {"has-error": this.isFieldInvalid("PostalCode")}])}>
                    <label htmlFor="inputPostalCode" className="control-label">{tr("Code postal")}</label>
                    <input type="text" id="inputPostalCode" className="form-control" value={this.props.shippingAddress.PostalCode || ""} onChange={this.handleOnChange.bind(this,"PostalCode")}></input>
                </div>

                <div className={cIf(["form-group", {"has-error": this.isFieldInvalid("Country")}])}>
                    <label htmlFor="inputCountry" className="control-label">{tr("Pays")}</label>
                    <input type="text" id="inputCountry" className="form-control" value={this.props.shippingAddress.Country || ""} onChange={this.handleOnChange.bind(this,"Country")}></input>
                </div>
                {formError}
                <div className="btn-toolbar pull-right">
                    <button type="button" id="btnCancel" className="btn btn-default" onClick={this.handleOnCancelEdition}>{tr("Annuler")}</button>
                    <button type="submit" id="btnConfirm"  className="btn btn-primary">{tr("Confirmer")}</button>
                </div>
            </form>
        );
    }
});

export class ProfileEmailModification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newEmail: "",
            newEmailConfirmation: "",
            errorMessage: "",
            disabled: false,
        };
    }

    handleOnChange(name, e) {
        this.setState({ [name]: e.target.value });
    }

    handleOnCancelEmailEdition() {
        this.props.onCancelEdition();
    }

    handleOnSave(e) {
        e.stopPropagation();
        e.preventDefault();
        this.setState({ disabled: true, hasFailed: false });
        tsRest.post(`/profiles/byuser/${this.props.userid}/emailchangerequest`, {
            newEmail: this.state.newEmail
        }).then(() => this.props.handleOnEditEmail()).catch(err => {
            if (err.body.Message === "EMAIL_EXIST") {
                this.setState({ hasFailed: true, errorMessage: tr("Courriel existant.") });
            }
            this.setState({disabled: false});
        });
    }

    render() {
        const disabled = this.state.newEmail === "" || this.state.newEmail !== this.state.newEmailConfirmation || this.state.disabled;
        const error = this.state.hasFailed ? <div className="alert alert-danger">{this.state.errorMessage}</div> : null;

        return (
            <React.Fragment>
                <div className="mdc-layout-grid__cell--span-12">
                    <h3 className="panel-tab-header">{tr("Modification de l'adresse courriel")}</h3>
                </div>
                <form onSubmit={this.handleOnSave.bind(this)}>
                    <div className="form-group">
                        <label htmlFor="inputDescription" className="control-label">{tr("Nouvelle adresse courriel")}</label>
                        <input type="email" id="email" className="form-control" value={this.state.newEmail} onChange={this.handleOnChange.bind(this,"newEmail")}></input>
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputName" className="control-label">{tr("Confirmez votre nouvelle adresse courriel")}</label>
                        <input type="email" id="newEmailConfirmation" className="form-control" value={this.state.newEmailConfirmation} onChange={this.handleOnChange.bind(this,"newEmailConfirmation")}></input>
                    </div>
                    <div className="btn-toolbar">
                        <button type="button" id="btnCancel" className="btn btn-default" onClick={this.handleOnCancelEmailEdition.bind(this)}>{tr("Annuler")}</button>
                        <button type="submit" id="btnConfirm" className="btn btn-primary" disabled={disabled}>{tr("Modifier")}</button>
                    </div>
                    {error}
                </form>

                <div className="alert alert-warning">
                    <p>{tr("Une fois votre demande de modification de votre courriel effectuée, un courriel sera envoyé à votre nouvelle adresse pour que vous puissiez confirmer la modification.")}</p>
                    <br />
                    <p>{tr("Veuillez prendre note qu’un courriel sera également envoyé à votre ancienne adresse pour mentionner la demande de changement.")}</p>
                </div>
            </React.Fragment>
        );
    }
    
}

ProfileEmailModification.propTypes = {
    onCancelEdition: PropTypes.func,
    handleOnEditEmail: PropTypes.func,
    userid: PropTypes.string
};
